function Loader({ fullScreen = true, message = 'Loading...' }) {
  const loaderContent = (
    <div className="flex flex-col items-center justify-center">
      <div className="relative w-16 h-16 mb-4">
        <div className="absolute inset-0 border-4 border-[color:var(--palette-accent)] border-t-transparent rounded-full animate-spin"></div>
        <div className="absolute inset-2 border-4 border-[color:var(--palette-accent)] border-t-transparent rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '0.8s' }}></div>
      </div>
      {message && (
        <div className="text-theme-secondary text-sm">{message}</div>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50 bg-theme-page">
        {loaderContent}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-8">
      {loaderContent}
    </div>
  );
}

export default Loader;
